export default __webpack_public_path__ + "static/media/20.1b32493a.png";